const checkDocs = (category, docs) => {
  category &&
    category.forEach((el) => {
      const result = docs && docs.findIndex((x) => x.id === el.id);
      if (result >= 0) {
        el.loaded = true;
        el.url = docs && docs[result].url;
      } else {
        el.loaded = false;
        el.url = "";
      }
    });
};

export default checkDocs;
